import './AssignmentPageModals.scss';

import React from 'react';
import Modal from 'components/Modal';
import moment from 'moment';

import AssignmentDetailsGrid from './AssignmentDetailsGrid';
import ModalButton from 'components/ModalButton';
import Thumbnail from 'components/Thumbnail';

import { FILE_TYPES, MODALS } from 'utils/constants';
import { ASSIGNMENT_STATES } from './../constants';
import { displayAssignmentStatus, stopAssignmentOrRemoveAssignment } from './../utils';

export default class AssignmentDetailsModal extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        deleteAssignment: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        openModal: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired,
        assignment: React.PropTypes.object.isRequired
    };

    _calculateCompletion() {
        let { assignment } = this.props;

        if(assignment.users.length === 0) {
            return 0;
        }

        let completedUsersCount = 0;
        assignment.users.forEach((user) => {
            let completedAll = true;
            let statusFoundForUser = false;
            assignment.contents.forEach((content) => {
                console.log(assignment, assignment.contentUserStatuses);
                assignment.contentUserStatuses.forEach((status) => {
                    if(status.contentId === content.id && status.userId === user.id) {
                        statusFoundForUser = true;

                        if(status.completed === false) {
                            completedAll = false;
                        }
                    }
                })
            });
            if(statusFoundForUser === true && completedAll === true) {
                completedUsersCount++;
            }
        });
        return completedUsersCount;
    }

    _calculateCompletionPercent(completedUserCount) {
        let { assignment } = this.props;

        if(assignment.users.length === 0) {
            return 0;
        }

        return Math.round((completedUserCount / assignment.users.length) * 100);
    }

    _generateAssignmentPartsString() {
        let parts = [];
        this.props.assignment.contents.forEach((part, index) => {
            if(index < 2) {
                if (part.type === 'file') {
                    parts.push(FILE_TYPES[part.file.contentType]);
                } else {
                    parts.push(part.type);
                }
            }
        });
        let contentLength = this.props.assignment.contents.length;
        if(contentLength > 2) {
            parts.push(`+ ${this.props.assignment.contents.length - 2} Other${contentLength > 3 ? 's' : ''}`);
        }
        return parts.join(', ');
    }

    _generateThumbnail() {
        let details = this.props.assignment.contents[0];

        if(details && details.type) {
            if(details.marketingType && details.marketingType === 'elearning') {
                return (
                    <Thumbnail defaultAvatar="elearning"
                               thumbnailID={null} />
                )
            } else {
                return (
                    <Thumbnail defaultAvatar={details ? details.type : 'assignments'}
                               thumbnailID={null}/>
                );
            }
        }
    }

    render() {
        let { assignment, closeModal, deleteAssignment, openModal, openEditModal, isSaving, show } = this.props;

        if(Object.keys(assignment).length > 0 && assignment.id != null && show === true) {

            let details = assignment.contents[0];


            let completedUserCount = this._calculateCompletion();
            let completedUserPercent = this._calculateCompletionPercent(completedUserCount);
            return (
                <Modal show={show}
                       className="assignment-details"
                       handleClose={closeModal.bind(this)}>
                    <header className="assignment-details__header modal__header">
                        <div className="assignment-details__thumbnail modal__thumbnail">
                            {details && details.thumbnail ? (
                                <div className="modal__thumbnail--image assignment-details__thumbnail--image">
                                    <img src={`${process.env.API_URL}rest/file/${details.thumbnail.id}`} alt={details.name} />
                                </div>
                            ) : this._generateThumbnail()}
                        </div>
                        {assignment.state === ASSIGNMENT_STATES.CANCELLED ? (
                            <div className={`progress-label progress-label--cancelled assignment-details__progress-label`}>
                                <span>
                                    {displayAssignmentStatus(assignment.state, assignment.status)}
                                </span>
                                <span>
                                    ({completedUserCount} <span>of</span> {assignment.users.length}) {completedUserPercent}% Complete
                                </span>
                            </div>
                        ) : (
                            <div className={`progress-label progress-label--${assignment.status} assignment-details__progress-label`}>
                                <span>
                                    {displayAssignmentStatus(assignment.state, assignment.status)}
                                </span>
                                <span>
                                    ({completedUserCount} <span>of</span> {assignment.users.length}) {completedUserPercent}% Complete
                                </span>
                            </div>
                        )}

                    </header>

                    <div className="assignment-details__name modal__name">
                        {assignment.name}
                    </div>

                    <AssignmentDetailsGrid assignment={assignment}
                                           handleContentClick={openModal.bind(this, MODALS.ASSIGNMENT_CONTENT_LIST)}
                                           handlePinpointsClick={openModal.bind(this, MODALS.ASSIGNMENT_PINPOINTS_LIST)}
                                           handleUsersClick={openModal.bind(this, MODALS.ASSIGNMENT_USERS_LIST)} />

                    <div className="details-modal__info assignment-details__info">
                        <div className="modal__name">
                            START: {assignment.startDate ? moment(assignment.startDate).format('M/D/YY') : '--'} | DUE: {assignment.dueDate ? moment(assignment.dueDate).format('M/D/YY') : '--'}
                        </div>
                        <div className="assignment-details__description modal__description">
                            Created by {assignment.creator.firstName} {assignment.creator.lastName} | {moment(assignment.created).format('MM/DD/YY')}
                        </div>
                        <div className="assignment-details__description modal__description assignment-details__various-details">
                            {assignment.mandatory === true ? 'Mandatory | ' : 'Optional | '}
                            {assignment.requireLocation === true ? 'Captures Location | ' : null}
                            {assignment.requireSignature === true ? 'Signature Required | ' : null}
                            {assignment.recurrance !== 'none' ? 'Recurring | ' : null}
                            {this._generateAssignmentPartsString()}
                        </div>
                    </div>

                    <div className="details-modal__info assignment-details__info">
                        <div className="modal__name">
                            Instructions
                        </div>
                        <div className="assignment-details__description modal__description">
                            {assignment.instructions || '[No specified instructions]'}
                        </div>
                    </div>

                    <div className="modal__buttons">
                        <ModalButton disabled={isSaving === true || [ASSIGNMENT_STATES.IN_PROGRESS, ASSIGNMENT_STATES.COMPLETED, ASSIGNMENT_STATES.CANCELLED].indexOf(assignment.state) !== -1}
                                     icon="edit"
                                     onClick={openEditModal.bind(this, assignment, MODALS.ASSIGNMENT_EDIT)}
                                     text="Edit" />
                        {/*<ModalButton disabled={isSaving === true}
                                     icon="play"
                                     onClick={openModal.bind(this, MODALS.ASSIGNMENT_EDIT)}
                                     text="Preview" />*/}
                        <ModalButton disabled={isSaving === true}
                                     icon="delete"
                                     onClick={deleteAssignment.bind(this, assignment)}
                                     text={stopAssignmentOrRemoveAssignment(assignment.state, assignment.status) === true ? 'Stop' : 'Remove'} />
                    </div>

                </Modal>
            )
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/modals/AssignmentDetailsModal.js